import { useToast } from 'provider/ToastProvider';
import React from 'react'
import { Modal } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";

function ShareProfileModal({show,handleClose}) {
  const { user_handle } = useParams();
  const { showWarningToast } = useToast();
  const fullUrl = `https://walkintothewild.in/profile/user/${user_handle}`;
    const copyToClipboard = async (link) => {
    try {
      await navigator.clipboard.writeText(link);
      showWarningToast("Link Copied");
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };
  return (
    <>
       <Modal show={show} onHide={handleClose} centered>
            <Modal.Header className="justify-content-center">
              <h2 className="modal-title fs-5">Share Profile</h2>
            </Modal.Header>
            <Modal.Body className="border-0">
              <div id="modalContent">
                <ul className="shrelinkssss ps-0 mb-0">
                  <ul>
                    <li>
                      <Link
                        to={`https://www.facebook.com/sharer/sharer.php?u=${fullUrl}`}
                        target="_blank"
                        className="iconSize"
                      >
                        <i className="fa-brands fa-facebook-f"></i>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`https://twitter.com/intent/tweet?url=${fullUrl}`}
                        target="_blank"
                        className="iconSize"
                      >
                        <i className="fa-brands fa-x-twitter"></i>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`https://www.instagram.com/?url=${fullUrl}`}
                        target="_blank"
                        className="iconSize"
                      >
                        <i className="fa-brands fa-instagram"></i>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`https://wa.me/?text=${fullUrl}`}
                        target="_blank"
                        className="iconSize"
                      >
                        <i className="fa-brands fa-whatsapp"></i>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`https://www.linkedin.com/shareArticle?mini=true&url=${fullUrl}`}
                        target="_blank"
                        className="iconSize"
                      >
                        <i className="fa-brands fa-linkedin-in"></i>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`https://telegram.me/share/url?url=${fullUrl}`}
                        target="_blank"
                        className="iconSize"
                      >
                        <i className="fa-solid fa-paper-plane pe-1"></i>
                      </Link>
                    </li>

                    <li>
                     <span
                      className="iconSize copytoclipboard"
                      onClick={() => {
                        copyToClipboard(fullUrl);
                      }}
                      data-href={`${fullUrl}`}
                    >
                      <i className="fa-solid fa-link"></i>
                    </span>
                    </li>
                  </ul>
                </ul>
              </div>
            </Modal.Body>
          </Modal>
    </>
  )
}

export default ShareProfileModal;